import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import classnames from 'classnames'

import Field from '../../../../components/Form/Field'
import Form from '../../../../components/Form'
import FieldLabelWrapper from '../../../../features/components/Form/FieldLabelWrapper'

import { getAppDomainName } from '../../../../features/helpers/getAppDomainName'

import {
  initialValues,
  transformValuesToBE,
  USER_FIRST_NAME,
  USER_LAST_NAME,
  USER_PASSWORD,
  validationSchema
} from '../fields'

import { acceptInvite, clearAcceptInvite } from '../../../../modules/actions/team'
import {
  acceptedInviteErrorSelector,
  acceptedInviteIsLoadingSelector,
  inviteWasAcceptedSelector
} from '../../../../modules/selectors/team'

import useAuthStyles from '../../../../styles/common/authPages'
import useDrawerFormStyles from '../../../../styles/common/drawerForms'

const AcceptInviteForm = ({ token, userCountry }) => {
  const authClasses = useAuthStyles()
  const drawerFormClasses = useDrawerFormStyles()

  const dispatch = useDispatch()

  const inviteWasAccepted = useSelector(inviteWasAcceptedSelector)
  const appName = getAppDomainName()

  const onSubmit = useCallback(
    values => {
      const transformedData = transformValuesToBE(values, userCountry, token)
      dispatch(acceptInvite(transformedData, true))
    },
    [dispatch, token, userCountry]
  )

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  })

  useEffect(() => {
    return () => {
      dispatch(clearAcceptInvite())
    }
  }, [dispatch])

  return (
    <>
      <Form
        formik={formik}
        method="post"
        successSubmit={inviteWasAccepted}
        isLoadingSelector={acceptedInviteIsLoadingSelector}
        errorSelector={acceptedInviteErrorSelector}
        submitText="Register"
      >
        <section className={classnames(drawerFormClasses.section, authClasses.section)}>
          <h3 className={drawerFormClasses.sectionTitle}>Let’s get you registered.</h3>
          <p>You’ve been invited to {appName}. Please fill in your details below.</p>
          <div className={authClasses.formRow}>
            <FieldLabelWrapper label={'First name'} labelFor={USER_FIRST_NAME}>
              <Field formik={formik} id={USER_FIRST_NAME} name={USER_FIRST_NAME} placeholder="First name" />
            </FieldLabelWrapper>
            <FieldLabelWrapper label={'Last name'} labelFor={USER_LAST_NAME}>
              <Field
                formik={formik}
                id={USER_LAST_NAME}
                name={USER_LAST_NAME}
                placeholder="Last name"
                autoComplete="off"
              />
            </FieldLabelWrapper>
          </div>
          <FieldLabelWrapper label={'Password'} labelFor={USER_PASSWORD}>
            <Field
              formik={formik}
              type="password"
              id={USER_PASSWORD}
              name={USER_PASSWORD}
              placeholder="New Password"
              autoComplete="new-password"
            />
          </FieldLabelWrapper>
          <p className={authClasses.description}>
            Passwords must contain at least 8 characters, one uppercase, one lowercase, one number and one special
            character
          </p>
        </section>
      </Form>
    </>
  )
}

export default AcceptInviteForm
